import { all, fork } from "redux-saga/effects";

import searchSaga from "./search.saga";
import relevantSearchSaga from "./relevantSearch.saga";
import systemSaga from "./system.saga";
import mainTreeSaga from "./mainTree.saga";
import settingsSaga from "./settings.saga";
import shopSaga from "./shop.saga";
import supportSaga from "./support.saga";
import swSaga from "./sw.saga";
import paragraphsReducerSaga from "./paragraphsReducer.saga";
import librarySaga from "./library.saga";
import playerSaga from "./player.saga";
import tocSaga from "./toc";
import _sharedSagaFeaturedSearch from "@/shared/store/featuredSearch/saga";

export default function* rootSaga() {
  yield all([
    fork(searchSaga),
    fork(relevantSearchSaga),
    fork(systemSaga),
    fork(mainTreeSaga),
    fork(settingsSaga),
    fork(shopSaga),
    fork(supportSaga),
    fork(paragraphsReducerSaga),
    fork(_sharedSagaFeaturedSearch),
    fork(swSaga),
    fork(librarySaga),
    fork(playerSaga),
    fork(tocSaga),
  ]);
}
